export const transformSSN = (ssn: string): string => {
  const ssnRegex = /^([\d][\d][\d]-[\d][\d]-[\d][\d][\d][\d])$/
  if (ssnRegex.test(ssn)) {
    return ssn
  }

  if (!ssn) {
    return ''
  }

  ssn = ssn.replace(/-/g, '')

  if (isNaN(+ssn)) {
    return ''
  }

  if (ssn.length < 4) {
    return ssn
  } else if (ssn.length >= 4 && ssn.length <= 5) {
    return ssn.substring(0, 3) + '-' + ssn.substring(3)
  } else {
    return ssn.substring(0, 3) + '-' + ssn.substring(3, 5) + '-' + ssn.substring(5, 9)
  }
}

export const isValidSSN = (ssn: string): boolean => {
  const ssnRegex = /^([\d][\d][\d]-[\d][\d]-[\d][\d][\d][\d])$/
  return ssnRegex.test(ssn)
}

export const getLast4SNN = (ssn: string | null): string | null => {
  if (ssn && isValidSSN(ssn)) return ssn.substring(7)
  else return null
}
